import { LocationDescriptor } from "history";
import { useLocation } from "react-router";
import { LocationState } from "types";

export type ModalLocationFactory = (
  pathname: string,
  state?: Omit<LocationState, "location">
) => LocationDescriptor<LocationState>;

export default function useModalLinkPrinter() {
  const location = useLocation<LocationState>();
  const getLocation: ModalLocationFactory = (pathname, state) => ({
    pathname,
    state: {
      ...state,
      location: location.state?.location || location,
    },
  });
  return {
    notification: location.state?.notification,
    getLocation,
  };
}
